import { environment } from 'src/environments/environment';

export class BaseAPIService {
  apiBaseUrl = environment.apiBaseUrl;
  baseUrl = environment.baseUrl;

  url(path: string): string {
    return `${this.apiBaseUrl}/${path}`;
  }

  asset(path: string): string {
    return `${this.baseUrl}/${path}`;
  }
}
